import React, { Component } from 'react';

export default class LoginLeft extends Component {
  render() {
    return <div className="login-left" />;
  }
}
